import React, { useState, useEffect } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import TitleBar from "../../../partials/content/TitleBar";
import { connect } from "react-redux";

function AllPreviewPagesSitePublisher({ role }) {
  const params = useParams();
  const sitePublisherID = params.id;
  const [sitePublisherData, setSitePublisherData] = useState();
  const [pages, setPages] = useState([]);

  useEffect(() => {
    const initDataComponent = async () => {
      await getSitePublisherData();
      await getAllPageInSitePublisher();
    };
    initDataComponent();
  }, []);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getSitePublisherData = async () => {
    setSitePublisherData(
      await sendRequestGetSitePublisherData(sitePublisherID)
    );
  };

  const sendRequestGetSitePublisherData = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let resultSitePublisherData;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      resultSitePublisherData = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultSitePublisherData.data.data;
  };

  const getAllPageInSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const pages = await sendRequestGetAllPageInSitePublisher();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!pages) {
      return;
    }

    setPages(pages);
  };

  const sendRequestGetAllPageInSitePublisher = async () => {
    const headersRequest = getHeaderForRequest();
    let allPageInSitePublisher;
    try {
      allPageInSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/page/site-publisher/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allPageInSitePublisher.data.data;
  };

  const generatePageSitePublisher = (pages) => {
    return (
      <>
        <div className="table-responsive pt-3">
          <table className="table table-hilite tbl-td-white-space table-hover">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره صفحه</td>
                <td>عنوان صفحه</td>
                <td>مشاهده صفحه</td>
                <td>جایگاه های تبلیغات</td>
              </tr>
            </thead>
            <tbody>
              {pages.map((page, index) => {
                return (
                  <tr>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>{helpersNumbers.toPersianNum(page.id)}</td>
                    <td>
                      {page.title}{" "}
                      {page.isMultiPage ? (
                        <span className="badge badge-danger">چند صفحه ای</span>
                      ) : (
                        <></>
                      )}
                    </td>
                    <td>
                      <a
                        href={page.link}
                        className="btn btn-info w-100"
                        target="_blank"
                      >
                        <i className="hl-view"></i>
                      </a>
                    </td>
                    <td>
                      <Link
                        to={`/publishers/preview/${page.id}/all-positions`}
                        className="btn btn-primary w-100"
                      >
                        نمایش جایگاه های تبلیغات
                      </Link>
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td>{helpersNumbers.toPersianNum(pages.length + 1)}</td>
                <td></td>
                <td>
                  جایگاه های مستقل
                  <span className="badge badge-warning">در تمامی صفحات</span>
                </td>
                <td></td>
                <td>
                  <Link
                    className="btn btn-primary w-100"
                    to={`/publishers/preview/${sitePublisherID}/all-independent-positions/`}
                  >
                    انتخاب جایگاه های تبلیغات
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const generateDoseNotHaveAnyPageInSitePublisher = () => {
    return (
      <>
        <div className="d-flex flex-column flex-md-row">
          <div className="text-center text-md-right">
            <img class="img-fluid" src="/assets/img/do-not-have-pages.svg" />
          </div>
          <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
            <p>این سایت در حال حاضر هیچ صفحه ای ندارد.</p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <TitleBar
          title={`صفحات سایت  ${sitePublisherData?.url.replace("http://", "")}`}
        />
        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to={() => {
                    if (role == "همکار") {
                      return "/publishers/coworker";
                    }
                    return "/publishers/all";
                  }}
                  className="btn btn-primary"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i class="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>

              {pages.length == 0
                ? generateDoseNotHaveAnyPageInSitePublisher()
                : generatePageSitePublisher(pages)}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    role: state.main.role,
  };
};

export default connect(mapStateToProps, null)(AllPreviewPagesSitePublisher);
